(function(){
  function improveDrawer(){
    var drawer=document.querySelector('.cart-drawer__dialog');
    if(!drawer)return;
    var summary=drawer.querySelector('.cart-drawer__summary');
    var ctas=drawer.querySelector('.cart__ctas');
    if(summary&&ctas&&!drawer.querySelector('#UMDrawerInfo')){
      var info=document.createElement('div');
      info.id='UMDrawerInfo';
      info.className='um-drawer-message';
      info.innerHTML='<span aria-hidden="true">◇</span> <strong>Pieza única</strong> <span aria-hidden="true">·</span> Asegura tu modelo al completar el pago';
      summary.insertBefore(info,ctas);
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',improveDrawer);
  else improveDrawer();
  document.addEventListener('shopify:section:load',improveDrawer);
  var drawerRoot=document.querySelector('cart-drawer, .cart-drawer, #CartDrawer');
  if(drawerRoot){
    var queued=false;
    new MutationObserver(function(){
      if(queued)return;
      queued=true;
      window.requestAnimationFrame(function(){queued=false;improveDrawer();});
    }).observe(drawerRoot,{childList:true,subtree:true});
  }
})();